module.exports = __webpack_public_path__ + "64fb773ac4cb6f9ede1aef1d99317d99.fbx";